export class DateInputModel {
    name: string;
    isReadOnly: boolean;
    isRequired: boolean;
    withTime: boolean;
    valueStr: string;   
    value: Date;   
    internalName: string; 
    dateFormat: string;
}